import NextEvent from "./NextEvent.jsx";

export default NextEvent;